import React from 'react'
import { TypePositionProvider } from '../../components/TypePosition/provider/typePositionProvider'
import TypePositionWrapper from '../../components/TypePosition/screens'

interface TypePositionPageProps {}

const TypePositionPage: React.FC<TypePositionPageProps> = () => {
  return (
    <TypePositionProvider>
      <TypePositionWrapper />
    </TypePositionProvider>
  )
}

export default TypePositionPage
